import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NzModalService, NzNotificationService } from "ng-zorro-antd";
import { FormsService } from "src/app/services/forms.service";
import { GetBranchByLocationModel, GetInformationBookingModel, QRCodeModel, RepresentativeModel } from "../../models/booking-request.model";
import { BookingService } from "../../services/booking.service";
import { FooterComponent } from "../footer/footer.component";
import { HeaderComponent } from "../header/header.component";

@Component({
    selector: 'app-component-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class HomeComponent implements OnInit, AfterViewInit {
    @ViewChild(HeaderComponent) header;
    @ViewChild(FooterComponent) footer;
    
    provinces = [];
    districts = [];
    branches = [];
    positions = [];
    productGroups = [];
    products = [];
    formServiceData: QRCodeModel
    provinceId: number;
    districtId: number;
    branchCode: string;
    productGroupId: number;
    productId: number;
    homeTimeId: number;
    homeForm: FormGroup;
    isInput = true;
    outputBranch: string;
    outputProduct: string;
    outputCustomerName: string;
    outputHomeTimeName: string;
    outputDateHome: string;
    outputHomeCode: string;
    imgQrCode: string;
    selectedProduct: any[];
    title = 'eFormClient';
    formCode: string;
    isMobile = window.innerWidth < 1000 ? true : false;
    current = 2;
    nzLoadingProvince = false;
    nzLoadingPosition = false;
    nzLoadingDistrict = false;
    nzLoadingBranch = false;
    nzLoadingHomeTime = false;
    nzLoadingProductGroup = false;
    nzLoadingProduct = false;
    isLoading = false;
    isSendingData: boolean = true;
    branchAddress: string;
    selectedProvince: string;
    code: string;
    taxCode: string;
    @ViewChild('buttonContinue') continueEl: ElementRef;

    constructor(private homeService: BookingService,
        private formService: FormsService,
        private formBuilder: FormBuilder,
        private nzModal: NzModalService,
        private nzNotification: NzNotificationService,
        private cdref: ChangeDetectorRef,
        private activeRoute: ActivatedRoute,
        private nzModalNotification: NzNotificationService,
        private router: Router) { }

    ngAfterViewInit(): void {
        this.continueEl.nativeElement.classList.add('d-disabled');

        //Active class DN header
        let CNEle = this.header.navEl.nativeElement.children[0].querySelector('a');
        if(CNEle.classList.contains('active')){
            CNEle.classList.remove('active');
        }

        let DNEle = this.header.navEl.nativeElement.children[1].querySelector('a');
        if(!DNEle.classList.contains('active')){
            DNEle.classList.add('active');
        }
        //ACtive class DN footer
        CNEle = this.footer.navEl.nativeElement.children[0].querySelector('a');
        if(CNEle.classList.contains('active')){
            CNEle.classList.remove('active');
        }

        DNEle = this.footer.navEl.nativeElement.children[1].querySelector('a');
        if(!DNEle.classList.contains('active')){
            DNEle.classList.add('active');
        }
    }

    ngOnInit() {
        this.getPosition();
        this.getProvince();
        let branchModel = new GetBranchByLocationModel();
        this.getBranch(branchModel);
        this.homeForm = this.formBuilder.group({
            companyName: null,
            taxCode: null,
            positions: [],
            customerName: null,
            phone: null,
            email: null,
            provinces: [],
            districts: [],
            branches: [],
            productGroups: [],
            products: [],
            acceptTermsConditions: null,
        });
        this.getFormByLinkOrQrCode();
    }

    getFormByLinkOrQrCode(){
        this.activeRoute.queryParams.subscribe(
            params => {
                this.code = params['data'];
                this.formCode = params['code'];
                this.taxCode = params['taxcode']
                if (this.code) {
                    this.formServiceData = { QRCode: this.code }
                    this.formService.getRepresentativeCorpByGuid(this.formServiceData).subscribe(res => {
                        if (res.result.isSuccess && res.result.value.result) {
                            let taxcode = res.result.value.result.taxCode;
                            let formCode = res.result.value.result.formCode
                            this.router.navigate(['/eform'], { queryParams: { code: formCode, taxcode: taxcode } });
                        }
                        else {
                            this.nzModalNotification.error("Error", "Có lỗi xảy ra khi xử lý dữ liệu");
                        }
                    }, error => {
                        this.nzModalNotification.error("Error", "Có lỗi xảy ra khi xử lý dữ liệu");
                    })
                }
                else if (this.formCode && this.taxCode) {
                    this.router.navigate(['/eform'], { queryParams: { code: this.formCode, taxcode: this.taxCode } });
                }
            }
        )
    }

    getProvince() {
        this.nzLoadingProvince = true;
        this.provinces = [];
        this.isSendingData = false;
        this.homeService.getProvince().subscribe(
            res => {
                if (res.result.isSuccess) {
                    this.provinces = res.result.value.result;
                }
                else {
                    this.nzNotification.error('ERROR', res.result.error);
                }
            },
            error => {
                this.nzNotification.error('ERROR', error);
            },
            () => {
                this.nzLoadingProvince = false;
                this.isSendingData = true;
            }
        )
    }

    getPosition() {
        this.nzLoadingPosition = true;
        this.positions = [];
        this.isSendingData = false;
        this.homeService.getPositions({ input: 'POSITION.WORKING' }).subscribe(
            res => {
                if (res.result.length > 0) {
                    let posWork = res.result.filter((x: { dataValueField: string | string[]; }) => !x.dataValueField.includes('Alert'));
                    this.positions = posWork;
                }
                else {
                    this.nzNotification.error('ERROR', res.result.error);
                }
            },
            error => {
                this.nzNotification.error('ERROR', error);
            },
            () => {
                this.nzLoadingProvince = false;
                this.isSendingData = true;
            }
        )
    }

    getBranch(model: GetBranchByLocationModel) {
        this.branches = [];
        this.branchAddress = "";
        this.isSendingData = false;
        this.homeService.getBranchByLocation(model).subscribe(
            res => {
                if (res.result.isSuccess) {
                    this.branches = res.result.value.result;
                    this.homeForm.get('branches').setValue(null);
                    this.homeForm.get('productGroups').setValue(null);
                    this.homeForm.get('products').setValue(null);
                }
                else {
                    this.nzNotification.error('ERROR', res.result.error);
                }
            },
            error => {
                this.nzNotification.error('ERROR', error)
            },
            () => {
                this.nzLoadingBranch = false;
                this.isSendingData = true;
            }
        )
    }

    changeProvince(event: any) {
        this.nzLoadingDistrict = true;
        this.isSendingData = false;
        this.districts = [];
        this.branches = [];
        this.productGroups = [];
        this.products = [];
        if (this.homeForm.get('provinces').value != null) {
            this.provinceId = this.homeForm.get('provinces').value.id;
            this.homeService.getDistrictByProvinceId(this.provinceId).subscribe(
                res => {
                    if (res) {
                        this.districts = res.result.value.result;
                    }
                    let model = new GetBranchByLocationModel();
                    model.provinceId = this.provinceId;
                    this.getBranch(model);
                    this.homeForm.get('districts').setValue(null);
                    this.homeForm.get('branches').setValue(null);
                    this.homeForm.get('productGroups').setValue(null);
                    this.homeForm.get('products').setValue(null);
                },
                error => {
                    this.nzNotification.error('ERROR', error);
                },
                () => {
                    this.nzLoadingDistrict = false;
                    this.isSendingData = true;
                }
            )
        }
    }

    changeDistrict() {
        this.isSendingData = false;
        if (this.homeForm.get('districts').value != null) {
            this.districtId = this.homeForm.get('districts').value.id;
            if (this.districtId) {
                this.nzLoadingBranch = true;
                this.branches = [];
                this.productGroups = [];
                this.products = [];
                let model = new GetBranchByLocationModel();
                model.provinceId = this.provinceId;
                model.districtId = this.districtId;
                this.getBranch(model);
            }
        }
    }

    changeBranch() {
        this.isSendingData = false;
        if (this.homeForm.get('branches').value != null) {
            this.branchCode = this.homeForm.get('branches').value.code;
            if (this.branchCode) {
                this.nzLoadingProductGroup = true;
                this.productGroups = [];
                this.products = [];
                let seletedBranch = this.branches.find(x => x.code == this.homeForm.get('branches').value.code);
                if (seletedBranch)
                    this.branchAddress = seletedBranch.address;

                this.homeService.getProductGroups(this.branchCode).subscribe(
                    res => {
                        if (res) {
                            this.productGroups = res.result.value.result;
                            let model = new GetInformationBookingModel();
                            model.branchCode = this.branchCode;
                        }

                        this.homeForm.get('productGroups').setValue(null);
                        this.homeForm.get('products').setValue(null);
                    },
                    error => {
                        this.nzNotification.error('ERROR', error)
                    },
                    () => {
                        this.nzLoadingProductGroup = false;
                        this.isSendingData = true;
                    }
                )
            }
        }
    }

    changeProductGroups() {
        this.isSendingData = false;
        if (this.homeForm.get('productGroups').value != null) {
            this.productGroupId = this.homeForm.get('productGroups').value.id;
            if (this.productGroupId) {
                this.nzLoadingProduct = true;
                this.products = [];
                this.homeService.getProductsByProductGroupId(this.productGroupId).subscribe(
                    res => {
                        if (res) {
                            this.products = res.result.value.result.filter(x => x.code.includes('DN'));
                        }
                        this.homeForm.get('products').setValue(null);
                    },
                    error => {
                        this.nzNotification.error('ERROR', error)
                    },
                    () => {
                        this.nzLoadingProduct = false;
                        this.isSendingData = true;
                    }
                )
            }
        }
    }

    changeProduct() {
        this.isSendingData = false;
        if (this.homeForm.get('products').value != null) {
            this.productId = this.homeForm.get('products').value.id;
            this.selectedProduct = this.products.filter(x => x.id == this.productId);
            this.formCode = (this.selectedProduct != null && this.selectedProduct.length > 0) ? this.selectedProduct[0].formCode : null;
        }
        this.isSendingData = true;
    }

    submitForm() {
        if (!this.checkValid())
            return;

        var formValue = this.homeForm.value;
        var representative = new RepresentativeModel();
        representative.customerName = formValue.customerName.toUpperCase();
        representative.companyName = formValue.companyName.toUpperCase();
        representative.taxCode = formValue.taxCode.toUpperCase();
        representative.position = formValue.positions.dataValueField;
        representative.phone = formValue.phone;
        representative.email = formValue.email;
        representative.branchCode = formValue.branches.code;
        representative.productId = formValue.products.id;
        representative.productGroupId = formValue.productGroups.id;
        let productObj = this.products.find(x => x.id == representative.productId);
        representative.formName = productObj.name;
        representative.formCode = productObj.formCode;
        this.isLoading = true;
        this.formService.createRepresentativeCorp(representative).subscribe(
            res => {
                if (res.result == null) {
                    this.nzNotification.error("ERROR", "Lỗi: Chức năng đăng ký bị lỗi! ")
                }
                else {
                    if (res.result.isSuccess) {
                        this.router.navigate(['/eform'], { queryParams: { code: this.formCode, taxcode: representative.taxCode } });
                    }

                }
                this.isLoading = false;
            },
            error => {
                this.nzNotification.error('ERROR', error);
                this.isLoading = false;
            }
        )
    }

    checkValid(): boolean {
        let customerName = this.homeForm.get('customerName').value;
        let position = this.homeForm.get('positions').value;
        let phone = this.homeForm.get('phone').value;
        let email = this.homeForm.get('email').value;
        let companyName = this.homeForm.get('companyName').value;
        let taxCode = this.homeForm.get('taxCode').value;
        let province = this.homeForm.get('provinces').value;
        let district = this.homeForm.get('districts').value;
        let branch = this.homeForm.get('branches').value;
        let productGroup = this.homeForm.get('productGroups').value;
        let product = this.homeForm.get('products').value;
        let acceptTermsConditions = this.homeForm.get('acceptTermsConditions').value;

        if (!customerName) {
            this.nzNotification.warning("WARNING", "Vui lòng nhập Họ tên")
            return false;
        }

        if (!position) {
            this.nzNotification.warning("WARNING", "Vui lòng nhập chức vụ")
            return false;
        }

        if (!phone) {
            this.nzNotification.warning("WARNING", "Vui lòng nhập Số điện thoại")
            return false;
        }

        if (!email) {
            this.nzNotification.warning("WARNING", "Vui lòng nhập Email")
            return false;
        }
        else {
            if (email.indexOf('@') < 0) {
                this.nzNotification.warning("WARNING", "Cảnh báo : Sai định dạng format email!");
                return false;
            }
        }

        if (!companyName) {
            this.nzNotification.warning("WARNING", "Vui lòng nhập tên Cty/Doanh nghiệp")
            return false;
        }

        if (!taxCode) {
            this.nzNotification.warning("WARNING", "Vui lòng nhập Tax Code")
            return false;
        }

        if (!province) {
            this.nzNotification.warning("WARNING", "Vui lòng nhập Tỉnh/Thành Phố")
            return false;
        }
        if (!district) {
            this.nzNotification.warning("WARNING", "Vui lòng nhập Quận/Huyện")
            return false;
        }

        if (!branch) {
            this.nzNotification.warning("WARNING", "Vui lòng chọn chi nhánh");
            return false;
        }

        if (!productGroup) {
            this.nzNotification.warning("WARNING", "Vui lòng chọn nhóm dịch vụ");
            return false;
        }
        if (!product) {
            this.nzNotification.warning("WARNING", "Vui lòng chọn sản phẩm");
            return false;
        }
        if (!acceptTermsConditions) {
            this.nzNotification.warning("WARNING", "Vui lòng chọn đồng ý chính sách SACOMBANK");
            return false;
        }

        return true;
    }

    urlTextQrCode(data: string) {
        if (data != "" && data != null) {
            if (data.length > 0 && data !== "-2" && data !== "-3") {
                this.imgQrCode = data;
            } else if (data === "-2") {
                this.nzNotification.warning("WARNING", "Cảnh báo : License Aspose có lỗi! ");
            } else if (data === "-3") {
                this.nzNotification.warning("WARNING", "Cảnh báo : Logo có lỗi!");
            }
        }
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.isMobile = window.innerWidth < 1000 ? true : false;
    }

    checkValidEmail() {
        let inputEmail = this.homeForm.get('email').value;
        if (this.homeForm.get('email').value) {
            if (inputEmail.indexOf('@') < 0) {
                this.nzNotification.warning("WARNING", "Cảnh báo : Sai định dạng format email!");
            }
        }
    }

    customSearch(event) {
        let term = event.term.normalize().toLowerCase()
        this.positions.filter(function (item) {
            return item.dataTextField.normalize().toLowerCase().indexOf(term) > -1
        })
    }

    checkValidWithoutNoti(): boolean {
        let customerName = this.homeForm.get('customerName').value;
        let position = this.homeForm.get('positions').value;
        let phone = this.homeForm.get('phone').value;
        let email = this.homeForm.get('email').value;
        let companyName = this.homeForm.get('companyName').value;
        let taxCode = this.homeForm.get('taxCode').value;
        let province = this.homeForm.get('provinces').value;
        let district = this.homeForm.get('districts').value;
        let branch = this.homeForm.get('branches').value;
        let productGroup = this.homeForm.get('productGroups').value;
        let product = this.homeForm.get('products').value;
        let acceptTermsConditions = this.homeForm.get('acceptTermsConditions').value;

        if (!customerName || 
            !position ||
            !phone ||
            !email ||
            (email && email.indexOf('@') < 0) ||
            !companyName ||
            !taxCode ||
            !province ||
            !district ||
            !branch ||
            !productGroup ||
            !product ||
            !acceptTermsConditions) return false;
        
        return true;
    }

    checkChanges(event: any){
        if(!this.checkValidWithoutNoti()){
            this.continueEl.nativeElement.classList.add('d-disabled');
        }
        else{
            this.continueEl.nativeElement.classList.remove('d-disabled');
        }
    }
}